import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import countBy from 'lodash/countBy';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import EcoRebatesAction from 'yoda-site-components/lib/actions/EcoRebatesAction';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './BundleEcoRebates.css';

const cx = classNames.bind(styles);

let allChildItemsWithRebates = [];

export class EcoRebates extends SiteComponent {
    static propTypes = {
        automationId: PropTypes.string,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        filteredItems: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        rebateInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        uiContext: PropTypes.string.isRequired,
    };

    static defaultProps = {
        automationId: '',
        actions: {},
        filteredItems: [],
        rebateInfo: {},
    };

    constructor() {
        super();
        this.state = {
            openRebatesModal: false,
        };
    }

    /* istanbul ignore next */
    componentWillReceiveProps(nextProps) {
        const { productOptions, uiContext } = nextProps;
        const filteredItems = Object.keys(productOptions).length
            ? productOptions.filteredItems
            : [];
        const itemsWithRebates = [];
        filteredItems.forEach((item) => {
            if (item.rebatesAvailable) {
                itemsWithRebates.push(item.id);
                allChildItemsWithRebates = [...allChildItemsWithRebates, item.id];
            }
        });
        const totalCount = countBy(allChildItemsWithRebates);
        if (itemsWithRebates.length && totalCount[itemsWithRebates[0]] === 1) {
            if (itemsWithRebates.length) {
                this.props.actions.getBundleEcoRebates({
                    itemsWithRebates: itemsWithRebates[0],
                    uiContext,
                    deliveryZipcode: nextProps.deliveryZipcode,
                    ppID: nextProps.productDetails.id,
                });
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.rebateInfo !== this.props.rebateInfo ||
            nextState.openRebatesModal !== this.state.openRebatesModal ||
            nextProps.deliveryZipcode !== this.props.deliveryZipcode
        );
    }

    openRebatesModal = () => {
        this.setState({
            openRebatesModal: true,
        });
    };

    closeRebatesModal = () => {
        this.setState({
            openRebatesModal: false,
        });
    };

    renderRebatesModal() {
        const rebateWidgetUrl = `https://jcpenney.ecorebates.com/ui/widgets/jcpenney/rebatedetails.html?ecr_skus=${this.props.rebateInfo.skuId}&ecr_uiContext=${this.props.uiContext}&ecr_zip=${this.props.deliveryZipcode}`;
        const rebatesMarkup = `<style>
            er-container {position: relative; margin-top: 20px; padding: 90% 45%; height: 0; overflow: auto;}
            .er-container iframe {position: absolute; top:0; left: 0;
              width: 100%; height: 100%; margin-top: 0px; padding: 0;}
          </style><div class="er-container"><iframe src=${rebateWidgetUrl}
            align="middle" frameborder="0"height="700" width="360" class="er-iframe">
            Content is not supported on this device</iframe></div>`;
        const rebateModalBlockStyle = dt(['h-[90%]']);
        const holderStyle = dt(['absolute', 'left-[5%]', 'top-[0]', 'w-[89%]', 'h-[85%]']);
        return (
            // eslint-disable-block
            <ModalBox
                showModal={this.state.openRebatesModal}
                onClose={this.closeRebatesModal}
                automationId="ecorebates-modal"
                modalTheme={`${cx('rebateModalBlock')} ${rebateModalBlockStyle}`}
                modalBlockTheme={cx('blockTheme')}
            >
                {/* eslint-disable react/no-danger */}
                <div
                    className={`${cx('holder')} ${holderStyle}`}
                    dangerouslySetInnerHTML={{ __html: rebatesMarkup }}
                />
            </ModalBox>
        );
    }

    renderRebateInfo() {
        const productRebatesDetails = this.props.rebateInfo.rebatesInfo.EcoRebatesResponse
            .productRebateDetails;
        const rebatesLinkStyle = dt(['text-link-hover', 'underline', 'text-sm']);
        return productRebatesDetails.map((rebate) =>
            rebate.maxRebate.amount > 0 ? (
                <div
                    className={cx('ecorebates-block')}
                    data-automation-id={this.props.automationId}
                >
                    <button
                        data-automation-id="rebatesLink"
                        className={`${rebatesLinkStyle} ${'rebates-link'}`}
                        onClick={this.openRebatesModal}
                    >
                        Up to ${rebate.maxRebate.amount} in Rebates Available
                    </button>
                    {this.state.openRebatesModal ? this.renderRebatesModal() : null}
                </div>
            ) : null
        );
    }

    render() {
        const { rebateInfo } = this.props;
        return (rebateInfo.rebatesInfo && rebateInfo.rebatesInfo.EcoRebatesResponse) ||
            this.state.openRebatesModal ? (
            <div> {this.renderRebateInfo()} </div>
        ) : null;
    }
}

const mapStateToProps = (state, ownProps) => ({
    rebateInfo: state.bundleEcoRebates ? state.bundleEcoRebates[ownProps.productDetails.id] : [],
    deliveryZipcode: state.deliveryZipcode,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(EcoRebatesAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EcoRebates);
